export default ({
	mentorGridCourse,
	mentorGridHeadline,
	mentorGridFilterTitle,
	loadMoreLabel,
	initialInViewMentorCount,
}) => {
	const transformMentorGridCourse = () => {
		return mentorGridCourse.map((course) => {
			return {
				...course,
				inViewMentorsCount:
					initialInViewMentorCount && !isNaN(initialInViewMentorCount)
						? Number(initialInViewMentorCount)
						: 9,
			};
		});
	};
	return {
		mentorGridCourse: transformMentorGridCourse(),
		mentorGridHeadline,
		mentorGridFilterTitle,
		loadMoreLabel: loadMoreLabel ? loadMoreLabel : "Load More",
		initialInViewMentorCount:
			initialInViewMentorCount && !isNaN(initialInViewMentorCount)
				? Number(initialInViewMentorCount)
				: 9,
	};
};
